import { FunctionComponent, useEffect, useState } from 'react';
import { Typography, IconButton, Table, TableRow, TableCell } from './../../tailwindcomponents';
import OverviewApi from './../../api/overview';
import { PackageInformationObj } from './../../types/overview';
import { redirectToMxi } from './../../config/mxiProvider';
import { AircraftInHangar } from '../../types/security';
import { Link } from '../icons';
import { useNavigate } from 'react-router-dom';
import CheckListIcon from './ChecklistIcon';

type SmallPackageInformationprops = {
  packageInformation: AircraftInHangar,
  supervisors: string[],
  onTailNumberClicked: Function
}

const SmallPackageInformation: FunctionComponent<SmallPackageInformationprops> = ({ packageInformation, supervisors, onTailNumberClicked }) => {
  const [workpackageStatistic, setWorkPackageStatistic] = useState(Array<PackageInformationObj>());
  const navigate = useNavigate();

  useEffect(() => {
    if (packageInformation.tail_number !== "") {
      OverviewApi.GetPackageInformationByTailNumber(packageInformation.tail_number, ["IN WORK"], false).then(res => {
        if (res.status === true) {
          setWorkPackageStatistic(res.data);
        }
      })
    }
  }, []);

  const generateTableBody = (row: PackageInformationObj, index: number) => {
    return (
      <TableRow>
        <TableCell>{index}</TableCell>
        <TableCell onClick={() => redirectToMxi(row.wo_barcode)}><IconButton><Link color="primary" /></IconButton></TableCell>
        <TableCell>{row.wo_name}</TableCell>
        <TableCell>{row.wo_actual_start_date_text === "" ? row.wo_schedule_start_date_text : row.wo_actual_start_date_text}</TableCell>
        <TableCell>{row.wo_actual_stop_date_text === "" ? row.wo_schedule_stop_date_text : row.wo_actual_stop_date_text}</TableCell>
      </TableRow>
    )
  }

  const redirectToSTM = () => {
    switch (packageInformation.bay_name) {
      case "Bay 1":
        navigate(`/staff-management/1`);
        break;
      case "Bay 2":
        navigate(`/staff-management/2`);
        break;
      case "Bay 3":
        navigate(`/staff-management/3`);
        break;
      case "Bay 4":
        navigate(`/staff-management/4`);
        break;
      case "Bay 5":
        navigate(`/staff-management/5`);
        break;
      case "Bay 6":
        navigate(`/staff-management/6`);
        break;
      case "Bay 7":
        navigate(`/staff-management/7`);
        break;
      case "Shops":
        navigate(`/staff-management/12`);
        break;
    }
  }

  return (
    <div className="flex flex-wrap">
      <div
          className="w-full"
          onClick={() => redirectToSTM()}
      >
        <Typography variant='h2' text={packageInformation.bay_name} align='center' cursor="pointer"/>
      </div>
      <div
        className="w-full flex flex-wrap justify-center items-center"
        onClick={() => onTailNumberClicked(packageInformation.tail_number)}
      >
        <Typography variant='h3' text={packageInformation.tail_number} />
        <CheckListIcon tailNumber={packageInformation.tail_number}/>
      </div>
      <div className="w-full">
        <Typography
          text={supervisors.length === 0 ?  "" :  "Supervisors: " + supervisors.map(name => name).join(" and ")}
          align='center'
        />
      </div>
      <div className="w-full">
        <Typography text={packageInformation.reason} align='center' />
      </div>
      <div className="w-full m-auto">
        {workpackageStatistic.length > 0 &&
          <Table
            headers={["", "Name", "Start", "End"]}
            rows={workpackageStatistic}
            generateBody={(row: any, index: number) => generateTableBody(row, index)}
            defaultRowsPerPage={5}
          />
        }
      </div>
    </div>
  );
};
export default SmallPackageInformation;